export default __webpack_public_path__ + "assets/oman-flag.png";